import { render, staticRenderFns } from "./min-width.vue?vue&type=template&id=0fe1e7b8&"
import script from "./min-width.vue?vue&type=script&lang=js&"
export * from "./min-width.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports